import { useQuery } from '@tanstack/react-query';
import { api, ApiCallError } from '@/lib/api';

export interface TenantMe {
  tenant: {
    id: string;
    fullName: string;
    displayName: string;
    whatsappNumber: string;
    email: string | null;
    status: 'onboarding' | 'active' | 'paused' | 'cancelled';
    companyName: string | null;
    companyAddress: string | null;
    companyPhone: string | null;
    companyEmail: string | null;
    companyWebsite: string | null;
    companySocials: string | null;
  };
  rucs: Array<{
    id: string;
    ruc: string;
    razonSocial: string;
    regimen: 'iva_irp' | 'ire_simple';
    isPrimary: boolean;
    validatedAt: string | null;
  }>;
  accountant: { adminId: string; fullName: string; email: string } | null;
  subscription: {
    id: string;
    plan: 'esencial' | 'pro';
    billingCycle: 'monthly' | 'annual';
    status: 'trialing' | 'active' | 'past_due' | 'cancelled';
    currentPeriodEnd: string;
  } | null;
  impersonatedBy: { id: string; fullName: string } | null;
}

export function useTenantMe() {
  return useQuery({
    queryKey: ['app-me'],
    queryFn: async () => {
      try {
        return await api<TenantMe>('/api/app/me');
      } catch (err) {
        if (err instanceof ApiCallError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 1000 * 60,
  });
}
